module.exports = __webpack_public_path__ + "img/stock5.a86bcc9c.png";